export default __webpack_public_path__ + "assets/terms-of-service.baca8a49faa9c9040d80c9226ee67d07.pdf";